import { Grid } from '@mui/material'

import { Map } from '../../types'
import MapCard from '../MapCard/MapCard'
import { getMapUrlForUser } from 'features/maps/utils'
import { useCurrentUser } from 'features/users/hooks/userQueryHooks'
import { openNewWindow } from 'features/common/utils/navigationUtils'

function MapsList({ maps }: { maps: Map[] }) {
  const me = useCurrentUser()

  const handleClick = (map: Map) => {
    const url = getMapUrlForUser(map, me)
    if (url) {
      openNewWindow(url)
    }
  }

  return (
    <>
      {maps.map((map, i) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={map.id + i}>
            <MapCard onClick={() => handleClick(map)} map={map} />
          </Grid>
        )
      })}
    </>
  )
}

export default MapsList
